export const _en = {
    label: {
        label: "Activity label"
    },
    suffix: {
        label: "Activity suffix"
    },
    trainingCourseModuleId: {
        label: "Module"
    },
    refGroupId: {
        label: "Crew type"
    },
    refTaskStageId: {
        label: "Planning stage"
    },
    duration: {
        label: "Duration"
    },
    group: {
        label: "Group"
    },
    quadGroup: {
        label: "QUAD group"
    },
    type: {
        label: "Activity type"
    },
    isFFS: {
        label: "Activity is FFS",
        tooltip: "An FFS's session is rule by specifics planification rules"
    },
    isToBePlanned: {
        label: "Is to be planned"
    },
    isVisualizationDisabled: {
        label: "No view"
    },
    isMotionDisabled: {
        label: "FBS sur FFS"
    },
    refMotorVersionsId: {
        label: "Version"
    },
    comment: {
        label: "Comment"
    },
    briefing: {
        label: "Briefing duration"
    },
    debriefing: {
        label: "Debriefing duration"
    },
    startDate: {
        label: "Start date and time"
    },
    finishDate: {
        label: "Finish date and time"
    },
    beginHourParam: {
        label: "Start hour from model"
    },
    updated: {
        label: "Last date modified"
    },
    updatedBy: {
        label: "Last modified by"
    }
};

export const _fr = {
    label: {
        label: "Libellé"
    },
    suffix: {
        label: "Suffixe"
    },
    trainingCourseModuleId: {
        label: "Journée / Module"
    },
    refGroupId: {
        label: "Type d'équipage"
    },
    refTaskStageId: {
        label: "Phase de planification"
    },
    duration: {
        label: "Durée"
    },
    group: {
        label: "Groupe"
    },
    quadGroup: {
        label: "Groupe de rattachement QUAD"
    },
    type: {
        label: "Type d'activité"
    },
    isFFS: {
        label: "Est de type FFS",
        tooltip: "Une séance FFS est soumise à des contraintes de planification spécifiques"
    },
    isToBePlanned: {
        label: "Est à planifier"
    },
    isVisualizationDisabled: {
        label: "Sans visuel (Option du simulateur)"
    },
    isMotionDisabled: {
        label: "FBS sur FFS (Option du simulateur)"
    },
    refMotorVersionsId: {
        label: "Changement de Version (Option du simulateur)"
    },
    comment: {
        label: "Commentaire"
    },
    briefing: {
        label: "Séance briefing"
    },
    debriefing: {
        label: "Séance débriefing"
    },
    startDate: {
        label: "Date et heure de début"
    },
    finishDate: {
        label: "Date et heure de fin"
    },
    beginHourParam: {
        label: "Heure de début par défaut"
    },
    updated: {
        label: "Dernière modification"
    },
    updatedBy: {
        label: "Dernier modificateur"
    }
};